import type {AttachmentSimpleResponse} from 'src/api/ProactApiClient';

export const IMAGE_EXTENSION_REGEX = /\.(png|jpe?g|gif|webp|heic)$/i;

export interface SplitAttachments {
  images: AttachmentSimpleResponse[];
  files: AttachmentSimpleResponse[];
}

/** Splits attachments into image (thumbnail-able) and non-image (link-only) groups by file extension. */
export const splitAttachmentsByImage = (
  attachments: AttachmentSimpleResponse[]
): SplitAttachments => ({
  images: attachments.filter(attachment =>
    IMAGE_EXTENSION_REGEX.test(attachment.name)
  ),
  files: attachments.filter(
    attachment => !IMAGE_EXTENSION_REGEX.test(attachment.name)
  ),
});
